import React from "react";
import clsx from "clsx";
import { CheckboxProps } from "./Checkbox.props";
import P from "../P/P";

const Checkbox: React.FC<CheckboxProps> = ({
	label,
	checked = false,
	onChange,
	disabled = false,
	className,
	labelClassName,
	toggleOnContainerClick = true,
}) => {
	const handleToggle = () => {
		if (!disabled && onChange) {
			onChange(!checked);
		}
	};

	return (
		<div
			className={clsx(
				"flex items-center space-x-2",
				disabled
					? "cursor-not-allowed opacity-50"
					: toggleOnContainerClick
						? "cursor-pointer"
						: "cursor-default",
				className,
			)}
			onClick={toggleOnContainerClick ? handleToggle : undefined}
		>
			<button
				type="button"
				className={clsx(
					"w-5 h-5 border rounded transition-colors duration-200 flex items-center justify-center",
					checked
						? "bg-light-mainColor dark:bg-dark-mainColor border-light-mainColor dark:border-dark-mainColor"
						: "bg-white border-stroke",
					disabled
						? "border-light-stroke dark:border-dark-stroke"
						: "hover:border-light-mainColor dark:border-dark-mainColor",
				)}
				onClick={(e) => {
					e.stopPropagation();
					handleToggle();
				}}
				disabled={disabled}
				aria-checked={checked}
				role="checkbox"
			>
				{checked && (
					<svg
						className="w-4 h-4 text-light-bgColor dark:text-dark-bgColor"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7.00024 13.0002L4.00024 10.0002L3.29324 10.7072L7.00024 14.4142L16.0002 5.4142L15.2932 4.7072L7.00024 13.0002Z"
							fill="currentColor"
						/>
					</svg>
				)}
			</button>

			{label && (
				<P
					size="t1"
					type="medium"
					className={clsx(
						"cursor-pointer transition-all duration-300",
						disabled
							? "text-stroke"
							: "hover:text-light-grayThree dark:text-dark-grayTtext-light-grayThree",
						labelClassName,
					)}
				>
					{label}
				</P>
			)}
		</div>
	);
};

export default React.memo(Checkbox);
